<email-layout>
  <ng-container logo>
    <email-referrals-logo [lang]="data.language" />
  </ng-container>

  <ng-container header>
    <ng-container *mailgunIf="data.referral_status_visible; else statusNotVisible">
      <email-message-header [header]="data.title" [subheader]="data.p1_true_html" />
    </ng-container>
    <ng-template #statusNotVisible>
      <email-message-header [header]="data.title" [subheader]="data.p1_false" />
    </ng-template>
  </ng-container>

  <ng-container body>
    <email-referral
      [candidateName]="data.candidate_name"
      [offerTitle]="data.offer_title"
      [jobButtonLink]="data.job_button_link"
      [jobButtonText]="data.job_button_text"
      [referralButtonLink]="data.referrals_button_link"
      [referralButtonText]="data.status_button_text"
      [referralStatusVisible]="data.referral_status_visible"
    />
  </ng-container>
</email-layout>
